import React from "react";

const WstethIcon: React.FC = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.2369 11L6.08524 11.2308C4.34114 14 4.72029 17.6154 7.07103 19.9231C8.36015 21.3077 10.1801 22 12 22C12 22 12 22 6.2369 11Z"
      fill="black"
    />
    <path
      opacity="0.6"
      d="M11.9999 14.3077L6.23682 10.9231C11.9999 22 11.9999 22 11.9999 22C11.9999 19.6154 11.9999 16.8462 11.9999 14.3077Z"
      fill="black"
    />
    <path
      opacity="0.6"
      d="M17.7631 11L17.9148 11.2308C19.6589 14 19.2797 17.6154 16.929 19.9231C15.564 21.3077 13.8199 22 12 22C12 22 12 22 17.7631 11Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M12 14.3077L17.7631 10.9231C12 22 12 22 12 22C12 19.6154 12 16.8462 12 14.3077Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M12 6.84616V12.6154L17.0048 9.76924L12 6.84616Z"
      fill="black"
    />
    <path
      opacity="0.6"
      d="M11.9999 6.84616L6.99512 9.76924L11.9999 12.6154V6.84616Z"
      fill="black"
    />
    <path d="M11.9999 2L6.99512 9.76923L11.9999 6.84615V2Z" fill="black" />
    <path
      opacity="0.6"
      d="M12 6.84615L17.0048 9.76923L12 2V6.84615Z"
      fill="black"
    />
  </svg>
);

export default WstethIcon;
